"use strict";

var _regeneratorRuntime = require("/home/runner/work/ami/ami/jaenjs/templates/jaen-template-shopify/node_modules/@babel/runtime/regenerator/index.js");

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnekFinder = void 0;

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

var React = _interopRequireWildcard(require("react"));

var _Finder = _interopRequireDefault(require("./components/organisms/Finder"));

var _ImageViewer = _interopRequireDefault(require("./components/organisms/ImageViewer"));

var _PdfViewer = _interopRequireDefault(require("./components/organisms/PdfViewer"));

var _SnekStudio = _interopRequireDefault(require("./components/organisms/SnekStudio"));

var _SnekFinderProvider = require("./SnekFinderProvider");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["mode"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var useSnekFinder = function useSnekFinder(_ref) {
  var mode = _ref.mode,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useSnekFinderContext = (0, _SnekFinderProvider.useSnekFinderContext)(),
      backend = _useSnekFinderContext.backend,
      initData = _useSnekFinderContext.initData,
      rootFileId = _useSnekFinderContext.rootFileId;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isSelectorOpen = _React$useState2[0],
      setIsSelectorOpen = _React$useState2[1];

  var _React$useState3 = React.useState(initData),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      data = _React$useState4[0],
      setData = _React$useState4[1];

  React.useEffect(function () {
    setData(initData);
  }, [initData]);
  React.useEffect(function () {
    var fn = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var index, newData, isDataDifferent;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return backend.readIndex();

              case 2:
                index = _context.sent; // check if data is different from index

                newData = index || initData;
                console.log('newData', newData);
                console.log('data', data);
                isDataDifferent = JSON.stringify(newData) !== JSON.stringify(data);
                console.log('isDataDifferent 11111', isDataDifferent);

                if (isDataDifferent) {
                  setData(newData);
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fn() {
        return _ref2.apply(this, arguments);
      };
    }();

    fn();
  }, [isSelectorOpen]);

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      openFile = _React$useState6[0],
      setOpenFile = _React$useState6[1];

  var openedFileItem = React.useMemo(function () {
    if (!openFile) {
      return null;
    }

    var fileId = openFile.fileId;
    var item = data[fileId];

    if (!item) {
      return null;
    } else if (item.isFolder) {
      return null;
    }

    return item;
  }, [openFile, data]);
  var handleDataChange = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newData) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return backend.writeIndex(newData);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [backend]);
  var handleFileOpen = React.useCallback(function (fileId) {
    var file = data[fileId];

    if (!file.isFolder) {
      var _ref4 = file,
          mimeType = _ref4.mimeType;

      if (mimeType && mimeType.startsWith('image/')) {
        setOpenFile({
          fileId: fileId,
          previewType: 'IMAGE_VIEWER'
        });
      } else if (mimeType && mimeType.startsWith('application/pdf')) {
        setOpenFile({
          fileId: fileId,
          previewType: 'PDF_VIEWER'
        });
      }
    }
  }, [data, setOpenFile]);
  var handleFinderClose = React.useCallback(function () {
    setOpenFile(null);
    setIsSelectorOpen(false);
  }, [setOpenFile, isSelectorOpen, setIsSelectorOpen]);
  var toggleSelector = React.useCallback(function () {
    setIsSelectorOpen(!isSelectorOpen);
  }, [isSelectorOpen, setIsSelectorOpen]);
  var toggleSelectorPreview = React.useCallback(function (fileId) {
    toggleSelector();
    handleFileOpen(fileId);
  }, [toggleSelector]);
  var toggleSelectorSelect = React.useCallback(function (_, file) {
    props.onSelect && props.onSelect(file);
    toggleSelector();
  }, [toggleSelector]);
  var finderElement = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [openFile && openedFileItem && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [openFile.previewType === 'IMAGE_VIEWER' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageViewer["default"], {
        src: openedFileItem.src,
        onOpenStudio: function onOpenStudio() {
          setOpenFile(_objectSpread(_objectSpread({}, openFile), {}, {
            previewType: 'SNEK_STUDIO'
          }));
        },
        onClose: function onClose() {
          return setOpenFile(null);
        }
      }), openFile.previewType === 'PDF_VIEWER' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_PdfViewer["default"], {
        src: openedFileItem.src,
        overlay: true,
        toolbar: true,
        onClose: function onClose() {
          return setOpenFile(null);
        }
      }), openFile.previewType === 'SNEK_STUDIO' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SnekStudio["default"], {
        src: openedFileItem.src,
        onComplete: /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(blob, dataURL) {
            var fileId, url, newData;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    fileId = openFile.fileId;
                    setData((0, _immutabilityHelper["default"])(data, _defineProperty({}, fileId, {
                      src: {
                        $set: dataURL
                      }
                    }))); // upload blob to backend

                    if (!blob) {
                      _context3.next = 9;
                      break;
                    }

                    _context3.next = 5;
                    return backend.upload(new File([blob], openedFileItem.name));

                  case 5:
                    url = _context3.sent;
                    newData = (0, _immutabilityHelper["default"])(data, _defineProperty({}, fileId, {
                      src: {
                        $set: url
                      }
                    }));
                    setData(newData);
                    backend.writeIndex(newData);

                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x2, _x3) {
            return _ref5.apply(this, arguments);
          };
        }(),
        onClose: function onClose() {
          return setOpenFile(_objectSpread(_objectSpread({}, openFile), {}, {
            previewType: 'IMAGE_VIEWER'
          }));
        }
      })]
    }), !(mode === 'selector' && !isSelectorOpen) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Finder["default"], {
      data: data,
      mode: mode,
      rootUUID: rootFileId,
      onItemOpen: handleFileOpen,
      onDataChanged: handleDataChange,
      onSelectorClose: handleFinderClose,
      onSelectorSelect: toggleSelectorSelect,
      onUploadFile: backend.upload
    })]
  });
  return {
    finderElement: finderElement,
    toggleSelector: toggleSelector,
    toggleSelectorPreview: toggleSelectorPreview
  };
};

exports.useSnekFinder = useSnekFinder;